import React from "react";
import { Link } from "react-router-dom";
import { Reveal, GovMark, DEMO_EMAIL } from "./MarketingUI";
import { Mail, ArrowRight } from "lucide-react";

export default function Contact() {
  const mailto = `mailto:${DEMO_EMAIL}?subject=${encodeURIComponent("GovFlowState demo request")}&body=${encodeURIComponent("Hello,\n\nWe'd like to see a demonstration of GovFlowState for our team.\n\nOrganization:\nRole:\nWhat we'd like to see:\n")}`;
  return (
    <>
      <section id="contact" className="relative overflow-hidden bg-[#F5F7FA] py-24 sm:py-28" data-testid="contact-section">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <Reveal>
            <div className="relative overflow-hidden rounded-3xl border border-brand-line bg-brand-navy px-7 py-14 text-center shadow-elevated sm:px-14">
              <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "linear-gradient(#3F7FB5 1px, transparent 1px), linear-gradient(90deg, #3F7FB5 1px, transparent 1px)", backgroundSize: "48px 48px" }} />
              <div className="relative">
                <img src="/govflow-mark.png" alt="" className="mx-auto h-12 w-12 object-contain" />
                <h2 className="mx-auto mt-6 max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
                  Modernize your legislative workflow.
                </h2>
                <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-white/65">
                  See how GovFlowState can bring legislative tracking, internal coordination, and reporting together.
                </p>
                {/* Email CTA — architected so it can later be swapped for a real demo-request form. */}
                <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-testid="contact-ctas">
                  <a href={mailto} className="group inline-flex items-center gap-2 rounded-full bg-brand-gold px-7 py-3.5 text-sm font-bold text-brand-navy-900 shadow-[0_10px_30px_-8px_rgba(214,160,29,0.7)] transition-transform hover:-translate-y-0.5" data-testid="contact-request-demo">
                    <Mail className="h-4 w-4" /> Request a GovFlowState Demo
                  </a>
                  <Link to="/login" className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10" data-testid="contact-signin">
                    Sign In <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
                <p className="mt-5 text-xs text-white/45" data-testid="contact-email">
                  Or email <a href={mailto} className="font-semibold text-brand-civic-100 underline-offset-2 hover:underline">{DEMO_EMAIL}</a>
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <footer className="border-t border-brand-line bg-white py-10" data-testid="landing-footer">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 px-5 sm:flex-row sm:px-8">
          <GovMark variant="dark" />
          <p className="text-center text-xs leading-relaxed text-brand-slate sm:text-right">
            Legislative workflow &amp; intelligence for state-government teams.
            <br className="hidden sm:block" />
            Florida is shown as a current live-data implementation. GovFlowState is a product of Rich AI Labs. © {new Date().getFullYear()} Rich AI Labs.
          </p>
        </div>
      </footer>
    </>
  );
}
